import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { retry } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class PaymentAuthService {
  private ispaymentAuthenticated: boolean = false;

  constructor(private http: HttpClient) {}

  customerPaymentLogin(loginDetails) {
    this.ispaymentAuthenticated = true;
    return this.http
      .post(
        `${environment.TRANSACTION_URL}/merchant-customer/login`,
        loginDetails
      )
      .pipe(retry(3));
  }

  createMerchantCustomer = (requestBody) =>
    this.http
      .post(
        `${environment.TRANSACTION_URL}/merchant-customer/signup`,
        requestBody
      )
      .pipe(retry(3));

  updateCustomerProfileInformation = (requestBody) =>
    this.http
      .put(
        `${environment.TRANSACTION_URL}/merchant-customer/userdetails`,
        requestBody
      )
      .pipe(retry(3));

  changePin = (requestBody) =>
    this.http.post(
      `${environment.TRANSACTION_URL}/merchant-customer/change-password`,
      requestBody
    );

  fetchHistoryByBranch = (email: string, country_code?: string) => {
    let url = `${environment.TRANSACTION_URL}/merchant-customer/${email}/history/branch`;
    if (!country_code) {
      return this.http.get(url).pipe(retry(3));
    } else {
      return this.http
        .get(url + `?country_code=${country_code}`)
        .pipe(retry(3));
    }
  };

  fetchBranchTransactions = (
    email: string,
    merchant_id: string,
    product_id?: string
  ) => {
    let url = `${environment.TRANSACTION_URL}/merchant-customer/${email}/history/branch/${merchant_id}`;
    if (!product_id) {
      return this.http.get(url).pipe(retry(3));
    } else {
      return this.http.get(url + `?product=${product_id}`).pipe(retry(3));
    }
  };

  fetchMerchantproducts = (merchantId: string) =>
    this.http
      .get(
        `${environment.TRANSACTION_URL}/merchant-customer/branch/products/${merchantId}`
      )
      .pipe(retry(3));

  fetchRecentBranches = (email: string) =>
    this.http
      .get(
        `${environment.TRANSACTION_URL}/merchant-customer/${email}/recent-payments/branch?branches=3`
      )
      .pipe(retry(3));

  fetchTransactionDetails = (id: string) =>
    this.http
      .get(
        `${environment.TRANSACTION_URL}/merchant-customer/history/transaction/${id}`
      )
      .pipe(retry(3));

  generatePublicKey = (merchantId) =>
    this.http
      .get(
        `${environment.TRANSACTION_URL}/merchant/public-key?merchant_id=${merchantId}`
      )
      .pipe(retry(3));

  fetchMerchantDetails = (merchantId: string): Observable<any> =>
    this.http
      .get(`${environment.TRANSACTION_URL}/merchant/${merchantId}`)
      .pipe(retry(3));

  fetchWciMerchants = () =>
    this.http
      .get(`${environment.TRANSACTION_URL}/merchant/wci/merchants`)
      .pipe(retry(3));

  fetchInstantPayment = (email: string) =>
    this.http
      .get(`${environment.TRANSACTION_URL}/payments/instant-payments/${email}`)
      .pipe(retry(3));

  fetchInstantPaymentDetails = (id: string) =>
    this.http
      .get(
        `${environment.TRANSACTION_URL}/payments/instant-payments/${id}/payments`
      )
      .pipe(retry(3));

  makeInstantPayment = (paymentId: string) =>
    this.http.get(
      `${environment.TRANSACTION_URL}/payments/instant-payment/${paymentId}`
    );

  fetchRecurringPayment = (email: string) =>
    this.http
      .get(
        `${environment.TRANSACTION_URL}/payments/recurring-payments/${email}`
      )
      .pipe(retry(3));

  fetchRecurringPaymentDetails = (id: string) =>
    this.http
      .get(
        `${environment.TRANSACTION_URL}/payments/recurring-payments/${id}/payments`
      )
      .pipe(retry(3));

  login = (payload: any) =>
    this.http.post(
      `${environment.TRANSACTION_URL}/merchant-customer/login`,
      payload
    );

  resetPin = (email: string) =>
    this.http
      .post(`${environment.TRANSACTION_URL}/merchant-customer/reset-password`, {
        email: email,
      })
      .pipe(retry(3));

  instantGive = (payload: any) =>
    this.http
      .post(`${environment.TRANSACTION_URL}/payments/instant-payments`, payload)
      .pipe(retry(3));

  recurringPayment = (payload: any) =>
    this.http
      .post(
        `${environment.TRANSACTION_URL}/payments/recurring-payments`,
        payload
      )
      .pipe(retry(3));

  deleteRecurringPayment = (id: string) =>
    this.http
      .delete(
        `${environment.TRANSACTION_URL}/payments/recurring-payments/${id}`
      )
      .pipe(retry(3));

  deleteInstantGive = (id: string) =>
    this.http
      .delete(`${environment.TRANSACTION_URL}/payments/instant-payments/${id}`)
      .pipe(retry(3));

  updateRecurringPayment = (id: string, payload) =>
    this.http
      .put(
        `${environment.TRANSACTION_URL}/payments/recurring-payments/${id}`,
        payload
      )
      .pipe(retry(3));

  updateInstantGive = (id: string, payload) =>
    this.http
      .put(
        `${environment.TRANSACTION_URL}/payments/instant-payments/${id}`,
        payload
      )
      .pipe(retry(3));

  addCard = (payload: any) => {
    const userCard = {
      cardNumber: payload.card_number,
      expirationDate: payload.expiry_date,
      cvv: payload.cvv,
      address: payload.address,
      town: payload.town,
      state: payload.state,
      zipCode: payload.zipCode,
    };
    return this.http.post(
      `${environment.TRANSACTION_URL}/paygate/add-card/${payload.email}`,
      userCard
    );
  };

  getCards = (email: string) =>
    this.http
      .get(`${environment.TRANSACTION_URL}/paygate/user/${email}/cards`)
      .pipe(retry(3));

  customerPaymentLogout(): void {
    // Your module-specific logout logic here
    this.ispaymentAuthenticated = false;
  }

  isPaymentModuleAuthenticated(): boolean {
    return this.ispaymentAuthenticated;
  }
}
